import { displayShortDate, displayPercent } from '../../utils/Format/Format';

const getPercentageSortFn = (prop) => (a, b) =>
    parseInt((prop ? a[prop] : a).split(' ')[0], 10) -
    parseInt((prop ? b[prop] : b).split(' ')[0], 10);

export const bondMaturityUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const {
        fund: { inceptionDate, maturities }
    } = gqlResult;

    const maturityElement = maturities[0] || {};
    const asOfDate = displayShortDate(maturityElement.asOfDate);

    const list = ['0 - 1 YRS', '1 - 5 YRS', '5 - 10 YRS', '10 + YRS'];

    const data = maturities
        .filter((elem) => list.includes(elem.name))
        .sort(getPercentageSortFn('name'))
        .map((ele) => ({
            label: ele.name.replace('YRS', 'Years'),
            values: [{ val1: displayPercent(ele.percentTotalNetAssets) }]
        }));

    return {
        data,
        asOfDate,
        inceptionDate
    };
};

const validateMaturities = (maturities) => {
    for (let i = 0; i < maturities.length; i++) {
        const rangeParts = maturities[i].name.split(' ');
        const startRange = parseInt(rangeParts[0], 10);

        if (startRange === undefined) {
            return false;
        }

        let endRange;

        if (rangeParts[1] === '-') {
            endRange = parseInt(rangeParts[2], 10);

            if (endRange === undefined) {
                return false;
            }
        }

        if (!endRange && startRange < 10) {
            return false;
        }

        if (
            (startRange === 0 && endRange > 1) ||
            (startRange >= 1 && startRange < 5 && endRange > 5) ||
            (startRange >= 5 && startRange < 10 && endRange > 10)
        ) {
            return false;
        }
    }

    return true;
};

const getRolledUpMaturities = (maturities) => {
    const areMaturitiesValid = validateMaturities(maturities);

    if (!areMaturitiesValid) {
        return [];
    }

    const { rangeMaturities, otherMaturities } = maturities.reduce(
        (acc, maturity) => {
            const startRange = parseInt(maturity.name.split(' ')[0], 10);

            if (Number.isNaN(startRange)) {
                acc.otherMaturities.push({
                    label: maturity.name,
                    values: [{ val1: displayPercent(maturity.percentOfFund) }]
                });
            } else {
                const rollMaturities = (range) => {
                    acc.rangeMaturities.set(
                        range,
                        (acc.rangeMaturities.get(range) || 0) +
                            maturity.percentOfFund
                    );
                };

                switch (true) {
                    case startRange === 0:
                        rollMaturities('0 - 1 Years');
                        break;
                    case startRange >= 1 && startRange < 5:
                        rollMaturities('1 - 5 Years');
                        break;
                    case startRange >= 5 && startRange < 10:
                        rollMaturities('5 - 10 Years');
                        break;
                    case startRange >= 10:
                        rollMaturities('10 + Years');
                        break;
                    default:
                }
            }

            return acc;
        },
        { rangeMaturities: new Map(), otherMaturities: [] }
    );

    const sortedRangeMaturities = [...rangeMaturities.keys()]
        .sort(getPercentageSortFn())
        .map((range) => ({
            label: range,
            values: [{ val1: displayPercent(rangeMaturities.get(range)) }]
        }));

    return [
        ...otherMaturities.sort((a, b) => a.label.localeCompare(b.label)),
        ...sortedRangeMaturities
    ];
};

export const bondMaturityUtilFI = (gqlResult) => {
    if (!gqlResult) return null;

    const {
        fund: {
            bondMaturity: { maturities, asOfDate },
            inceptionDate
        }
    } = gqlResult;

    return {
        inceptionDate,
        asOfDate: displayShortDate(asOfDate),
        data: getRolledUpMaturities(maturities)
    };
};
